import { PropsWithClassName } from "../../types/PropsWithClassName";

interface NoResultsFoundProps extends PropsWithClassName {
  text?: string;
}

export const NoResultsFoundText = "Nu exista niciun rezultat!";

export default function NoResultsFound({ className, text = NoResultsFoundText }: NoResultsFoundProps) {
  return <div className={`${className} text-center`}>{text}</div>;
}
